import React, { useCallback, useEffect, useState } from 'react';
import Flex from 'components/shared-components/Flex';
import { Col, Table, Typography } from 'antd';
import apiClient from 'services/apiClient';
import { iso2ToFlagEmoji } from 'utils/phoneCountry';
import { useSelector } from 'react-redux';

const { Text } = Typography;

const formatSell = (value) => `₹${Number(value || 0).toFixed(2)}`;

const TenantSellRatesTable = ({ api, authToken, id, balance, balanceLoading }) => {
    const themeData = useSelector((auth) => auth.theme);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSellRates = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`${api}user-pricing/${id}/sell-rates`, {
                headers: { Authorization: `Bearer ${authToken}` },
            });
            setRows(response?.data?.data || []);
        } catch (error) {
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, [api, authToken, id]);

    useEffect(() => {
        fetchSellRates();
    }, [fetchSellRates]);

    const columns = [
        {
            title: 'Country',
            dataIndex: 'country_name',
            key: 'country_name',
            render: (_, record) => (
                <span>
                    <span style={{ marginRight: 8 }} aria-hidden>
                        {iso2ToFlagEmoji(record.country_iso2)}
                    </span>
                    <Text strong>{record.country_name}</Text>
                    <Text type="secondary" style={{ marginLeft: 6, fontSize: 12 }}>
                        ({record.country_iso2})
                    </Text>
                </span>
            ),
        },
        {
            title: 'Marketing',
            dataIndex: 'marketing_price',
            key: 'marketing_price',
            align: 'right',
            render: (value) => formatSell(value),
        },
        {
            title: 'Utility',
            dataIndex: 'utility_price',
            key: 'utility_price',
            align: 'right',
            render: (value) => formatSell(value),
        },
        {
            title: 'Service',
            dataIndex: 'service_price',
            key: 'service_price',
            align: 'right',
            render: (value) => formatSell(value),
        },
        {
            title: 'Auth',
            dataIndex: 'authentication_price',
            key: 'authentication_price',
            align: 'right',
            render: (value) => formatSell(value),
        },
    ];

    return (
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <div
                className="border-0 rounded p-3 h-100"
                style={{
                    background: themeData.currentTheme === 'dark' ? '#1b2531' : '#fafafb',
                    boxShadow: 'rgba(27, 37, 49, 0.1) 0px 2px 10px',
                    minHeight: 280,
                }}
            >
                <Flex justifyContent="space-between" alignItems="flex-start" className="mb-3">
                    <div>
                        <h4 className="mb-0">Message Pricing</h4>
                        <Text type="secondary" style={{ fontSize: 13 }}>
                            Per-message rates in INR (final price)
                        </Text>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
                            Available credit
                        </Text>
                        <Text strong style={{ fontSize: 22, lineHeight: 1.2 }}>
                            {balanceLoading ? '...' : `₹${Number(balance || 0).toFixed(2)}`}
                        </Text>
                    </div>
                </Flex>
                <Table
                    rowKey="country_iso2"
                    columns={columns}
                    dataSource={rows}
                    loading={loading}
                    pagination={false}
                    size="middle"
                />
            </div>
        </Col>
    );
};

export default TenantSellRatesTable;
